import { getAuthToken } from '../../../utils/auth';
import {
  searchReportingFetch as fetch,
  searchReportingLegacyUrl,
} from '../../../lib/flags/search-reporting';

const DASHBOARD_RECORD_VALIDATORS = {
  contact: {
    endpoint: '/validate/contact',
    queryParam: 'contactID',
    label: 'contact',
    invalidGeneratedPattern: /^contact_/i,
    invalidGeneratedMessage:
      'That looks like a generated placeholder, not a CharityStack contact ID. Use the exact contactId returned by contact search.',
    notFoundMessage:
      'That contact ID was not found in the active organization. Search for the contact first and use the returned contactId.',
  },
  form: {
    endpoint: '/validate/form',
    queryParam: 'formID',
    label: 'form',
    notFoundMessage:
      'That form ID was not found in the active organization. Search for the form first and use the returned formId.',
  },
  element: {
    endpoint: '/validate/element',
    queryParam: 'elementID',
    label: 'element',
    notFoundMessage:
      'That element ID was not found in the active organization. Search for the element first and use the returned elementId.',
  },
};

export async function validateDashboardRecordId(recordType, id) {
  const normalizedId = id?.trim?.();
  const validator = DASHBOARD_RECORD_VALIDATORS[recordType];
  if (!validator) {
    return { isValid: false, message: `Unsupported dashboard record type: ${recordType}.` };
  }

  if (!normalizedId) {
    return { isValid: false, message: `${validator.label} ID is required.` };
  }

  if (validator.invalidGeneratedPattern && validator.invalidGeneratedPattern.test(normalizedId)) {
    return {
      isValid: false,
      message: validator.invalidGeneratedMessage,
    };
  }

  const opensearchUrl = searchReportingLegacyUrl;
  if (!opensearchUrl) {
    return { isValid: false, message: `${validator.label} validation is not configured.` };
  }

  try {
    const token = await getAuthToken();
    const response = await fetch(
      `${opensearchUrl}${validator.endpoint}?${validator.queryParam}=${encodeURIComponent(normalizedId)}`,
      {
        method: 'GET',
        headers: {
          accept: '*/*',
          'content-type': 'application/json',
          Authorization: token,
        },
      },
    );

    if (!response.ok) {
      return { isValid: false, message: `Unable to validate that ${validator.label} ID.` };
    }

    const data = await response.json();
    return {
      isValid: Boolean(data?.isValid),
      message: data?.isValid ? undefined : validator.notFoundMessage,
    };
  } catch (error) {
    console.warn(`Failed to validate dashboard assistant ${recordType} id:`, error);
    return { isValid: false, message: `Unable to validate that ${validator.label} ID.` };
  }
}
